import type { Card } from "@amzn/ads-blink-client";
import type { AsyncState, UseAsyncActions } from "@react-hookz/web";
import { useAsync } from "@react-hookz/web";

import { getCustomerId } from "../../api/adsApi/adsApi.config";
import { getBlinkApiClientV2 } from "../../api/blinkApi/blinkApi";
import { authStore } from "../../store/auth";
import { getUnifiedSearchQueryExpressionV2 } from "../../utils/unifiedContent.utils";
import { useAutoFetch } from "../misc/useAutoFetch";
import { useAsyncErrorStatusNotification } from "../notifications/useAsyncErrorStatusNotification";

export interface SearchInsightFamilyTypesResponse {
    content: Card[];
    totalHits: number;
}

export const emptyResponse: SearchInsightFamilyTypesResponse = {
    content: [],
    totalHits: 0,
};

export interface SearchInsightFamilyTypesProps {
    advertiserId?: string;
    marketplaceId?: string;
    autoFetch?: boolean;
}

export function useSearchInsightFamilyTypes({
    advertiserId,
    marketplaceId,
    autoFetch = false,
}: SearchInsightFamilyTypesProps): [
    AsyncState<SearchInsightFamilyTypesResponse>,
    UseAsyncActions<SearchInsightFamilyTypesResponse, []>,
] {
    const [state, action] = useAsync(async () => {
        const client = await getBlinkApiClientV2();
        return (await client.searchInsightFamilyTypes({
            advertiserId,
            marketplaceId,
            clientId: window.location.host,
            queryExpression: getUnifiedSearchQueryExpressionV2(),
            userAlias: authStore.getState().username,
            customerId: getCustomerId(),
        })) as SearchInsightFamilyTypesResponse;
    }, emptyResponse);

    useAutoFetch(action, autoFetch);
    useAsyncErrorStatusNotification(state);
    return [state, action];
}
